module.exports = __webpack_public_path__ + "static/assets/a0cb5aeb52541d110a10381eb6c05894.png";